import React from 'react';
import { observer } from 'mobx-react-lite';
import { Icon, Typography, Button, Scrollbar } from '@ann/web-components';
import { 
    GranteesListContainerExternal, 
    GranteesListContainerInternal, 
    GranteeItem, 
    GranteeInfo, 
    GranteeActions, 
    TitleDescriptionContainer, 
    titleAndListContainer 
} from '../Modal.styled';
import { NameInitialsAvatar } from 'react-name-initials-avatar';

const PendingAgentsList = observer(({
    pendingAgents,
    onRemove
}) => {
    if (pendingAgents.length === 0) return null;

    return (
        <titleAndListContainer>
            <TitleDescriptionContainer>
                <Typography category="subtitle" size="small" weight="bold" color="subtitle">
                    To be added
                </Typography>
                <Typography category="body" size="medium" weight="regular" color="body">
                    You're about to add {pendingAgents.length} agents
                </Typography>
            </TitleDescriptionContainer>

            <GranteesListContainerExternal>
                <Scrollbar size="small">
                    <GranteesListContainerInternal>
                        {pendingAgents.map((agent) => (
                            <GranteeItem key={agent.uuid}>
                                <GranteeInfo>
                                    <NameInitialsAvatar
                                        name={agent.name}
                                        bgColor="#2563eb"
                                        textColor="#ffffff"
                                        size="24px"
                                        borderRadius="50%"
                                        textWeight="bold"
                                        textSize="18px"
                                        borderColor="#ffffff"
                                        borderStyle="solid"
                                        borderWidth="2px"
                                    />
                                    <Typography
                                        category="body"
                                        size="medium"
                                        weight="regular"
                                        color="body"
                                    >
                                        {agent.name}
                                    </Typography>
                                </GranteeInfo>
                                <GranteeActions>
                                    <Button
                                        icon="close"
                                        size="medium"
                                        type="tertiary"
                                        onClick={() => onRemove(agent.uuid)}
                                    />
                                </GranteeActions>
                            </GranteeItem>
                        ))}
                    </GranteesListContainerInternal>
                </Scrollbar>
            </GranteesListContainerExternal>
        </titleAndListContainer>
    );
});

export default PendingAgentsList;
